import { gql } from '@apollo/client';

export const GET_PROJECT_TYPES = gql`
  query GET_PROJECT_TYPES($ids: [ID!], $state: State) {
    projectTypes(ids: $ids, state: $state) {
      id
      name
      description
      disabled
      seq
    }
  }
`;

export const ADD_PROJECT_TYPE = gql`
  mutation ADD_PROJECT_TYPE($input: AddProjectTypeInput!) {
    addProjectType(input: $input) {
      id
      name
      seq
    }
  }
`;

export const UPDATE_PROJECT_TYPE = gql`
  mutation UPDATE_PROJECT_TYPE($input: UpdateProjectTypeInput!) {
    updateProjectType(input: $input) {
      id
      name
      seq
    }
  }
`;
